import classNames from 'classnames';
import React, { useEffect, useRef } from 'react';
const ErrorBox = (props) => {
    // const step = useSelector(getStep) || 'shipping';
    let errorBoxRef = useRef(null);
    useEffect(() => {
        if (props.errors && props.errors.length > 0) {
            errorBoxRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }, [props.errors]);
    if (!props.errors || props.errors.length === 0 || props.errors.every((err) => err === '')) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { className: classNames('globalerrors', 'alert-error', props.className), role: "alert", ref: errorBoxRef },
        React.createElement("span", null,
            React.createElement("svg", { className: 'icon--error icon-s no-stroke', "aria-hidden": "true" },
                React.createElement("use", { href: '#sprite-error' }))),
        props.errors.map((e, i) => (React.createElement("div", { key: i }, (e || '').toString()))),
        React.createElement("button", { className: 'close-alert', type: 'button', "aria-label": props.ariaLabel || 'Chiudi', onClick: () => {
                props.setErrors([]);
                // urlUtils.removeErrorParamCheckout(step);
            } },
            React.createElement("svg", { className: 'icon--close-black icon-s no-stroke', "aria-hidden": "true" },
                React.createElement("use", { href: '#sprite-close-black' })))));
};
export default ErrorBox;
